module.exports = __webpack_public_path__ + "np.9f2d8bc5.svg";